import {z} from 'zod';
import { RequestMeta } from '../RequestMeta';
import { Store } from '../../stores/Store';

export const StoreLocationsResponse = z.object({
  meta: RequestMeta,
  data: z.array(Store),

})

export type StoreLocationsResponse = z.infer<typeof StoreLocationsResponse>;
